
import { Vue, Component, Watch } from 'vue-property-decorator';

import GET_USER from '@/apollo/main/GetUser.gql';

import * as Sentry from '@sentry/browser';

import { Company, User } from '@/generated/graphql';
import auth from '@/services/auth';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import TooltipVariants from '@/entities/TooltipVariants';
import INSERT_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/InsertProjectActivityTime.gql';
// import INSERT_PROJECT_ACTIVITY_TIME from '@/apollo/timesheet/InsertTimesheetActivityTrackedTime.gql';
import convertSecondsToReadable from '@/utils/convertSecondsToReadable';
import UPDATE_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/UpdateProjectActivityTime.gql';
import moment from 'moment';

@Component({
	components: { LoadingOverlay, Tooltip },
	apollo: {
		currentUser: {
			query: GET_USER,
			variables() {
				return {
					id: this.currentUserId,
				};
			},
			skip() {
				return this.skipQuery;
			},
			update: (data) => {
				return data.user_by_pk;
			},
		},
	},
})
export default class App extends Vue {
	currentUser?: User = undefined;
	currentUserId: string = '';
	TooltipVariants = TooltipVariants;
	myTimerRunning: boolean = false;
	myTimerTitle: string = '';
	convertSecondsToReadable = convertSecondsToReadable;

	@Watch('currentUser')
	onCurrentUser(): void {
		Vue.prototype.$currentUser = this.currentUser;

		this.startTimer();
	}

	get loading(): boolean {
		return this.$apollo.queries.currentUser.loading;
	}

	mounted() {
		// @ts-ignore
		window.intercomSettings = {
			app_id: 'hixuxmld',
		};
	}

	created(): void {
		this.checkAuth();
		this.requestNotificationPermission();
		this.$root.$on('notify', (messageAndTitle: any) => {
			this.notify(messageAndTitle);
		});
		Vue.prototype.$currentUser = this.currentUser;
		Vue.prototype.$company = this.company;

		this.startTimer();
		this.$root.$on('timerStarted', () => {
			this.myTimerRunning = true;
			this.startTimer();
		});
		this.$root.$on('timerStopped', () => {
			this.stopTimer();
		});
	}

	startTimer(): void {
		if (this.currentUser && window.location.pathname !== '/signin') {
			if (localStorage.getItem('timerOwner' + this.currentUser.id)) {
				var timerOwner = localStorage.getItem(
					'timerOwner' + this.currentUser.id
				);
				if (
					timerOwner === '1' &&
					localStorage.getItem('timerRecorded') &&
					localStorage.getItem('timerRunning') === '1'
				) {
					this.myTimerRunning = true;
					this.myTimerTitle = localStorage.getItem('activity')
						? JSON.parse(localStorage.getItem('activity')).title
						: 'No title provided';
					if (
						localStorage.getItem('timerRunning') === '1' &&
						!localStorage.getItem('appTimer')
					) {
						var timerInterval = window.setInterval(() => {
							if (document.getElementById('appTimerLabel')) {
								document.getElementById(
									'appTimerLabel'
								).innerHTML = this.getTimer();
							}
						}, 1000);
						localStorage.setItem(
							'appTimer',
							timerInterval.toString()
						);
					}
					if (localStorage.getItem('appTimer')) {
						var timerInterval = Number(
							localStorage.getItem('appTimer')
						);
						window.clearInterval(timerInterval);
						localStorage.removeItem('appTimer');

						var timerInterval = window.setInterval(() => {
							if (document.getElementById('appTimerLabel')) {
								document.getElementById(
									'appTimerLabel'
								).innerHTML = this.getTimer();
							}
						}, 1000);
						localStorage.setItem(
							'appTimer',
							timerInterval.toString()
						);
					}
				}
			}
		} else {
			this.stopTimer();
		}
	}

	stopTimer(): void {
		this.myTimerRunning = false;
		// localStorage.setItem('timerRunning', '0');
		var timerInterval = Number(localStorage.getItem('appTimer'));
		window.clearInterval(timerInterval);
		localStorage.removeItem('appTimer');
		// document.getElementById('appTimerLabel').innerHTML = this.getTimer();
		this.myTimerRunning = false;
	}
getEndTimeWithtrackDate(){
		const localstorageTrackedDate = localStorage.getItem('tracked_date')
		if(localstorageTrackedDate){

			const trackedDate = new Date(localstorageTrackedDate)

				const currentTime = new Date();
				const currseconds = currentTime.getSeconds();
				const currminutes = currentTime.getMinutes();
				const currhours= currentTime.getHours();
				const currmilis= currentTime.getMilliseconds();
				trackedDate.setHours(currhours);
				trackedDate.setSeconds(currseconds);
				trackedDate.setMinutes(currminutes);
				trackedDate.setMilliseconds(currmilis)
				return trackedDate
		}
		return new Date()
}
	async saveTimer(): Promise<void> {
		this.stopTimer();

		localStorage.setItem('stopTime', this.getEndTimeWithtrackDate().toString());
		var time = 0;
		var startTime = new Date(localStorage.getItem('startTime'));
		var endTime = new Date(localStorage.getItem('stopTime'));
		if (
			!localStorage.getItem('startTime') ||
			!localStorage.getItem('stopTime')
		) {
			time = 0;
		} else {
			var diff = endTime.getTime() - startTime.getTime();
			time = diff / 1000;
		}

		var activity = JSON.parse(localStorage.getItem('activity'));
		const start_time = new Date(startTime).toTimeString().split(' ')[0]
		const end_time = new Date(endTime).toTimeString().split(' ')[0]
		// const tracked_date = new Date(localStorage.getItem('tracked_date'))
		const tracked_date = moment(localStorage.getItem('tracked_date')).local()
			.format('YYYY-MM-DD');
		var projectActivityTime = {
			activity_id: activity.id,
			// user_id: this.currentUser.id,
			// company_id: activity.company_id,
			contractor_id: activity.contractor_id,
			notes: activity.note || '',
			time: time,
			start_time,
			end_time,
			tracked_date,
			timesheet_id: activity.timesheet_id || activity.timesheetId
		};

		if(activity.isEdit){
			var obj = {
				notes: activity.note,
				time: time,
				start_time,
				end_time,
				tracked_date,
				timesheet_id: activity.timesheet_id || activity.timesheetId
			};
			await this.$apollo.mutate({
				mutation: UPDATE_PROJECT_ACTIVITY_TIME,
				variables: {
					id: activity.activity_id,
					obj: obj,
				},
			});
		}else {

			await this.$apollo.mutate({
				mutation: INSERT_PROJECT_ACTIVITY_TIME,
				variables: {
					projectActivityTime: projectActivityTime,
				},
			});
		}
		this.$root.$emit("timerStopped");
		this.discardTimer();
	}

	discardTimer(): void {
		localStorage.removeItem('startTime');
		localStorage.removeItem('stopTime');
		localStorage.removeItem('timerRecorded');
		localStorage.removeItem('timerRunning');
		localStorage.removeItem('activity');
		localStorage.removeItem('appTimer');
		localStorage.removeItem('timerOwner' + this.currentUser.id);
		localStorage.removeItem('tracked_date');

		if (localStorage.getItem('timerInterval')) {
			var timerInterval = Number(localStorage.getItem('timerInterval'));
			window.clearInterval(timerInterval);
			localStorage.removeItem('timerInterval');
		}
	}

	getTimer(): string {
		var secsDiff = 0;
		if (
			!localStorage.getItem('timerRunning') &&
			localStorage.getItem('startTime') &&
			localStorage.getItem('stopTime')
		) {
			secsDiff =
				new Date(localStorage.getItem('stopTime')).getTime() -
				new Date(localStorage.getItem('startTime')).getTime();
			secsDiff = secsDiff / 1000;
		}
		if (
			localStorage.getItem('startTime') &&
			(!localStorage.getItem('stopTime') ||
				localStorage.getItem('timerRunning'))
		) {
		let endTime = this.getEndTimeWithtrackDate();
				secsDiff =
				// new Date().getTime() -
				endTime.getTime() -
				new Date(localStorage.getItem('startTime')).getTime();
			secsDiff = secsDiff / 1000;
		}
		return this.convertSecondsToReadable(secsDiff);
	}

	updated(): void {
		this.checkAuth();
	}

	@Watch('isAuthenticated')
	onAuthChange(): void {
		this.$apollo.queries.currentUser.skip = !this.isAuthenticated;
	}

	@Watch('currentUser')
	onUserChange() {
		if (this.currentUser) {
			Sentry.setUser({
				id: this.currentUser.id,
				email: this.currentUser.email,
			});

			const intercomSettings = {
				app_id: 'hixuxmld',
				user_id: this.currentUser.id,
				name: `${this.currentUser.given_name} ${this.currentUser.family_name}`,
				email: this.currentUser.email,
				// @ts-ignore
				created_at: this.$moment(this.currentUser.created_at),
				'User Type': this.currentUser.role,
				'Cognito ID': this.currentUser.id,
				company: {
					plan: 'BASIC',
					company_id: this.company ? this.company.id : null,
					name: this.company ? this.company.business_name : null,
					website: this.company ? this.company.website : null,
					industry: this.company ? this.company.industry : null,
					size: this.company ? this.company.number_of_employee : null,
				},
			};

			this.$apollo.queries.currentUser.stopPolling();
			// @ts-ignore
			window.intercomSettings = { ...intercomSettings };
		}
	}

	get company(): Company | null | undefined {
		if (this.currentUser) {
			switch (this.currentUser.role) {
				case 'ADMIN':
					return this.currentUser?.admin?.company ?? null;
				case 'MANAGER':
					return this.currentUser?.manager?.company ?? null;
				default:
					return null;
			}
		}
	}

	get isAuthenticated(): boolean {
		return Boolean(this.currentUserId);
	}

	async checkAuth() {
		this.currentUserId = await auth.getSessionUserId();
	}

	clearUserInfo(): void {
		this.currentUser = undefined;
		this.stopTimer();
	}

	onRefetch(): void {
		this.currentUser = undefined;
		this.$apollo.queries.currentUser.refetch();
		this.startTimer();
	}

	async requestNotificationPermission(): Promise<void> {
  if (Notification.permission === 'denied' || Notification.permission === 'default') {
    await Notification.requestPermission();
  }
}

	notify(messageAndTitle: any): void {
		if (Notification.permission === 'granted') {
			const img = require('./assets/jobbliss_logo.png');
			const title = messageAndTitle[1];
			const message = messageAndTitle[0];
			const link = messageAndTitle[2];
			var notification = new Notification(title, {
				body: message,
				icon: img,
			});
			notification.onclick = (event) => {
				window.focus();
				window.location.href = link;
			};
		}
	}
}
